$(function() {
  var txt_sold_out = 'Out of stock';

  var product_bundles = $('.product-bundle');
  if (product_bundles.length > 0) {
    
    product_bundles.each(function() {
      var _t = $(this),
          requests = [],
          variant_ids = [],
          products = _t.find('li.product-bundle-data'),
          btn = _t.find('button.product-bundle-add-to-cart');

      products.each(function() {
        var variant_id = $(this).data('variant');
        variant_ids.push(variant_id);

        var handle = $(this).data('handle');
        var request = $.ajax({
          url: "/products/"+handle+".js",
          dataType: 'json',
        });
        requests.push(request);
      });

      $.when.apply($, requests).then(function() {
        if (requests.length == 1) arguments = [arguments];
        $.each(arguments, function(i, res) {
          var data = res[0],
              status = res[1];
          
          if (status == 'success') {
            var variant_id = variant_ids[i],
                selected_variant;
            $.each(data.variants, function(j, variant) {
              if (variant.id == variant_id && !variant.available) {
                selected_variant = variant;
                btn.html(txt_sold_out).addClass('disabled').attr('disabled');
                return false;
              }
            });
          } else {
            btn.html(txt_sold_out).addClass('disabled').attr('disabled');
          }
        });
      });
    });

    
    $('.product-bundle-add-to-cart').click(function(event) {
      var _t = $(this);
      _t.addClass('disabled').attr('disabled');
      var data_products = [];
      var products = $(this).parents('.product-bundle').find('li.product-bundle-data');

      products.each(function() {
        var variant_id = $(this).data('variant');

        data_products.push({
          quantity: 1,
          id: variant_id
        });
      });

      $.ajax({
        type: "post",
        url: "/cart/add.js",
        data: {
          items: data_products
        }, 
        dataType: 'json',
        success: function(data, text, xhr) { 
          
          $('.error-message').text('');
          $('.Drawer--right').addClass('active');
          $('.offcanvas-cart').addClass('active');
          $('.backdrop').addClass('active');
          $('body').addClass('ov-h');
          gred.updateMinicart();
          
        },
        error: function(xhr, text, err) {
          _t.removeClass('disabled').removeAttr('disabled');

          $('.header-actions-list-item.header-cart-link').trigger('click');
          gred.updateMinicart();
        },
        complete: function() {
          _t.removeClass('disabled').removeAttr('disabled');
        }
      });
    });
  }
});